import { useIsSuperTenant, usePermissions } from "@/features/auth/hooks/usePermissions";

/**
 * Persona Opportunities IAM is tenant-scoped (KTD13): Super Tenant membership
 * alone does not unlock list/create/tuning. Use `perms.*.isOn` — not
 * `useIamPermission`, which ORs in the platform Super Tenant bypass.
 */
export function usePersonaOpportunityPermissions() {
  const perms = usePermissions();
  const isSuperTenant = useIsSuperTenant();
  const canListSets = perms.PERSONA_OPPORTUNITY_SETS_LIST.isOn;
  const canCreateSet = perms.PERSONA_OPPORTUNITY_SETS_GENERATE.isOn;

  return {
    canListSets,
    canCreateSet,
    /**
     * Name-only empty Custom set — the one KTD13 exception (AD-3328): platform
     * admins who can open the hub may create it without GENERATE. Checks
     * membership, not the active org's type (`useIsActiveSuperTenant` is false
     * in a customer org). Never widen `canCreateSet` instead — it also gates
     * delete, rename, regenerate, stop, and retry.
     */
    canCreateEmptyCustomSet: canCreateSet || (isSuperTenant && canListSets),
    /** Same ACTION as create — gates persona script generate (U6 / U11). */
    canGenerateScripts: perms.PERSONA_OPPORTUNITY_SETS_GENERATE.isOn,
    canUseQueryTuning: perms.PERSONA_OPPORTUNITY_SETS_QUERY_TUNING.isOn,
    /** Leftover Create Set — required to offer Competitor driven generate. */
    canGenerateCompetitorSet: perms.OPPORTUNITY_SETS_CREATE.isOn,
  };
}
